import { crudSelectorsCustom } from 'redux/crudCreatorCustom/selector';
import { MODEL_NAME } from './actions';

export const unownedProvidersOfUserSelectors = crudSelectorsCustom(MODEL_NAME);
